import { useCallback } from 'react';
import {
  loadCompliancePdf,
  type CompliancePdfDocument,
} from '@ots-frontend/ots-data';
import { useApp } from '../app/AppContext';
import { OtsPdfViewer } from '../components/OtsPdfViewer';
export const CompliancePdfPreview = ({
  document,
  label,
  compact,
}: {
  document: CompliancePdfDocument;
  label: string;
  compact?: boolean;
}) => {
  const app = useApp();
  const load = useCallback(
    (signal: AbortSignal) => {
      if (!app?.baseQueryApi)
        return Promise.reject(
          new Error('The document service is unavailable.')
        );
      return loadCompliancePdf(document, app.baseQueryApi, signal);
    },
    [app?.baseQueryApi, document.program, document.id, document.tenantCode]
  );
  return (
    <OtsPdfViewer
      documentKey={JSON.stringify([
        document.program,
        document.tenantCode,
        document.id,
      ])}
      title={label}
      fileName={`${document.program}-${document.id}.pdf`}
      loadPdf={load}
      compact={compact}
    />
  );
};
